import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import {
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "~/components/ui/Accordions/Accordion/Accordion";
import type { AccordionItemStoryblok } from "~/generated/sb/blok-types";
import styles from "./AccordionBlok.module.css";

export const AccordionItemBlok = ({ blok, preview }: BlokProps<AccordionItemStoryblok>) => {
	return (
		<BlokWrap asChild editable={blok}>
			<AccordionItem className={styles.item}>
				<AccordionTrigger>{blok.title}</AccordionTrigger>
				<AccordionContent>
					{blok.content?.map((blok) => (
						<StoryblokComponent preview={preview} blok={blok} key={blok._uid} />
					))}
				</AccordionContent>
			</AccordionItem>
		</BlokWrap>
	);
};
